<template>
    <ComponentGridComponent
        :componentGridGroups="componentGridGroups"
    />
</template>

<script>
import ComponentGridComponent from '@vueapp/components/ComponentGridComponent.vue'

export default {
    components: {
        ComponentGridComponent
    },
    data() {
        return {
            templateData: {},
        }
    },
    props: {
        postSlug: String,
        postId: String
    },
    methods: {

    },
    computed: {
        componentGridGroups() {
            if(this.templateData) {
                // console.log('this.templateData.components_grid::', this.templateData)
                return this.templateData ?? {}
            }
        },
    },
    async beforeCreate() {
        const params = new URLSearchParams(window.location.search),
            eParams = {}

        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+\ ]+)$/) ) {
                eParams[name] = value
            }
        })
        const paramsString = ( new URLSearchParams(eParams) ) .toString()

        fetch( BRYTER.homeUrl + '/component-grid/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
            .then(response => response.json())
            .then(data => {
                console.log('data::', data.components_grid.components_data)
                this.templateData = data.components_grid.components_data
                // this.loading = false
            })
    }
}
</script>